import React, { useState } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { JobsProvider } from './context/JobsContext';
import LoginPage   from './pages/LoginPage';
import RunPage     from './pages/RunPage';
import HistoryPage from './pages/HistoryPage';
import Topbar      from './components/Topbar';

function Shell() {
  const { user } = useAuth();
  const [page, setPage] = useState('run');

  if (!user) return <LoginPage />;

  return (
    <div style={{ display:'flex', flexDirection:'column', minHeight:'100vh' }}>
      <Topbar activePage={page} setPage={setPage} />
      <main style={{
        flex:1, padding:'28px 32px', overflowY:'auto',
        maxWidth: 1500, width:'100%', margin:'0 auto',
      }}>
        {page === 'run'     && <RunPage />}
        {page === 'history' && <HistoryPage />}
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <JobsProvider>
        <Shell />
      </JobsProvider>
    </AuthProvider>
  );
}